import { type FunctionComponent } from 'react';
import { type HomePageImageFieldsFragment, type TrackingLinkFieldsFragment } from '../../../__generated__/graphql-client-types';
import { PLACEHOLDER_OPTIONS } from '../../../constants/cloudinary/general';
import { type CloudinaryOptions } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { Link } from '../../common-components/link/link.component';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';

export type HomeBannerProps = {
	desktop: HomePageImageFieldsFragment;
	mobile: HomePageImageFieldsFragment;
	link: TrackingLinkFieldsFragment;
};

export const HomeBanner: FunctionComponent<HomeBannerProps> = ({ desktop, mobile, link }) => {
	const imageOptions: CloudinaryOptions = {
		height: 327,
		width: undefined
	};
	const { name, url, tracking } = link;

	return (
		<section className="flex flex-column items-center w-100 h-100" data-testid="home-banner">
			<Link url={url} analyticsHook={tracking} ariaLabel={name}>
				<CloudinaryImage
					className="dn db-ns"
					publicID={desktop.id}
					description={desktop.description}
					options={imageOptions}
					useDimensions={false}
					placeholderOptions={{
						...imageOptions,
						...PLACEHOLDER_OPTIONS
					}}
					lowQualityPlaceholder={desktop.lowQualityPlaceholder}
				/>
				<CloudinaryImage
					className="db dn-ns"
					publicID={mobile.id}
					description={mobile.description}
					options={imageOptions}
					useDimensions={false}
					placeholderOptions={{
						...imageOptions,
						...PLACEHOLDER_OPTIONS
					}}
					lowQualityPlaceholder={mobile.lowQualityPlaceholder}
				/>
			</Link>
		</section>
	);
};
